import React, { FC, memo } from 'react';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import { MenuItem } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { FieldLabel } from '..';

import useStyles from './styles';
import { SelectFieldProps } from './SelectFieldModels';
import { useCommonStyles } from '../../../styles';

export const SelectField: FC<SelectFieldProps> = memo(({ name, label, options, disabled, isRequired, description, errors, onChange, children, selectClass, placeholder, labelClass, classRequired, id, defaultValue, icon }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  return (
    <div>
      {label && <FieldLabel label={label} isRequired={isRequired} description={description} classLabel={labelClass} classRequired={classRequired} icon={icon} />}

      <Field
        defaultValue={defaultValue}
        displayEmpty
        component={Select}
        name={name}
        disabled={disabled}
        disableUnderline
        id={id}
        inputProps={{
          classes: {
            icon: classes.selectIcon,
          },
          IconComponent: ExpandMore,
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
            
          },
        }}
        className={`${classes.inputContainer} ${selectClass} ${errors ? classes.inputError : ''}`}
        {...Object.assign(onChange ? { onChange } : {})}
      >
        <MenuItem disabled key="0" value="">
          {placeholder !== '' ? placeholder : 'Please select...'}{' '}
        </MenuItem>
        {(options &&
          options.map((elem: any) => (
            <MenuItem className={commonClasses.optionSelector} key={`${name}-${elem.label}-${elem.value}`} value={elem.value}>
              {elem.label}
            </MenuItem>
          ))) ||
          children}
      </Field>
      {errors && <span className={classes.errorDescription}>{errors}</span>}
    </div>
  );
});
